<template>
    <div>
        <rednax-datatable
            :url="'/vue/products?mode=purchasesuggestion&is_struct=0&needs_purchase=1'"
            :columns="table_columns"
            :filter="table_filter_purchased"
            size="md"
            :per-page="1000"
            sort-by="ProdID"
            sort-order="asc"
            ref="purchasesitemstablepurchased"
        >
            <template #header>
                <h5 class="card-title">Ej beställda produkter</h5>
            </template>
            <div class="row">
                <div class="col-lg-3">
                    <input type="text" v-model="table_filter_purchased.search" class="form-control"  placeholder="Sök...">
                </div>
            </div>
            <template #cell_images="{ row }">
                <div v-if="row.images && row.images.length > 0">
                    <img :id="`product-image-${row.ProdID}`" :src="row.images[0].urls['small']" :alt="row.ProdID" style="height: 60px; margin: -8px 0;">
                    <!--                    <div v-if="row.images.length > 1" style="margin-top: 8px; margin-bottom: -8px;">{{ row.images.length }} bilder i popup</div>-->
                    <b-popover :target="`product-image-${row.ProdID}`" triggers="hover">
                        <img :src="row.images[0].urls['medium']" :alt="row.ProdID" style="width: 100%;">
                    </b-popover>
                </div>
            </template>
            <template #cell_isOutOfStock="{ row }">
                <div v-if="row.isStruct" class="badge badge-info">STRUKTURARTIKEL</div>
                <div v-if="row.isPhasedOut === 1" class="badge badge-danger">HAR UTGÅTT</div>
                <div v-else-if="row.isOutOfStock === 1" class="badge badge-danger">TILLF. SLUT</div>
                <div class="text-success font-weight-semibold font-size-sm text-nowrap" v-if="row.first_delivery_date">Första leverans {{ row.first_delivery_date.substring(0, 10) }}</div>
                <div class="text-muted font-size-sm text-nowrap" v-if="row.ReorderingMailTS">Varnad {{ row.ReorderingMailTS.substring(0, 10) }}</div>
            </template>
        </rednax-datatable>

        <rednax-datatable
            :url="'/vue/products?mode=purchasesuggestion&is_struct=0&has_purchase=1'"
            :columns="table_columns"
            :filter="table_filter_not_purchased"
            size="md"
            :per-page="1000"
            sort-by="ProdID"
            sort-order="asc"
            ref="purchasesitemstable"
        >
            <template #header>
                <h5 class="card-title">Beställda produkter</h5>
            </template>
            <div class="row">
                <div class="col-lg-3">
                    <input type="text" v-model="table_filter_not_purchased.search" class="form-control"  placeholder="Sök...">
                </div>
            </div>
            <template #cell_images="{ row }">
                <div v-if="row.images && row.images.length > 0">
                    <img :id="`product-image-${row.ProdID}`" :src="row.images[0].urls['small']" :alt="row.ProdID" style="height: 60px; margin: -8px 0;">
                    <!--                    <div v-if="row.images.length > 1" style="margin-top: 8px; margin-bottom: -8px;">{{ row.images.length }} bilder i popup</div>-->
                    <b-popover :target="`product-image-${row.ProdID}`" triggers="hover">
                        <img :src="row.images[0].urls['medium']" :alt="row.ProdID" style="width: 100%;">
                    </b-popover>
                </div>
            </template>
            <template #cell_isOutOfStock="{ row }">
                <div v-if="row.isStruct" class="badge badge-info">STRUKTURARTIKEL</div>
                <div v-if="row.isPhasedOut === 1" class="badge badge-danger">HAR UTGÅTT</div>
                <div v-else-if="row.isOutOfStock === 1" class="badge badge-danger">TILLF. SLUT</div>
                <div class="text-success font-weight-semibold font-size-sm text-nowrap" v-if="row.first_delivery_date">Första leverans {{ row.first_delivery_date.substring(0, 10) }}</div>
                <div class="text-muted font-size-sm text-nowrap" v-if="row.ReorderingMailTS">Varnad {{ row.ReorderingMailTS.substring(0, 10) }}</div>
            </template>
            <template #cell_Stock_future="{ row }">
                <span v-if="row.has_purchase">{{ row.Stock_future + parseInt(row.ordered_total, 10) }}</span>
                <span v-else>{{ row.Stock_future }}</span>
            </template>
        </rednax-datatable>
    </div>
</template>

<script>
import RednaxDatatable from '@components/Datatable/RednaxDatatableComponent';

export default {
    name: 'PurchaseSuggestionList',
    components: {
        RednaxDatatable,
    },
    data: () => ({
        row_id: null,
        derived_row_id: null,
        table_filter_purchased: {
            search: '',
        },
        table_filter_not_purchased: {
            search: '',
        },
        table_columns: [
            {
                header: '#',
                data: 'ProdID',
                sortable: true,
                render(row) {
                    return '<a href="/products/' + row.ProdID + '">' + row.ProdID + '</a>';
                },
            },
            {
                header: 'Bild',
                data: 'images',
                sortable: false,
            },
            {
                header: 'Produkt',
                data: 'ProdName',
                sortable: true,
                render(row) {
                    return '<a href="/products/' + row.ProdID + '">' + row.ProdName + '</a>';
                },
            },
            {
                header: 'Leverantör',
                data: 'SupplierName',
                sortable: true,
                render(row) {
                    return row.ProdSupplierID > 0 ? '<a href="/suppliers/' + row.ProdSupplierID + '">' + row.SupplierName + '</a>' : '';
                },
            },
            // {
            //     header: 'Lev. Artnr.',
            //     data: 'ProdSupplierSKU',
            //     sortable: true,
            // },
            {
                header: 'Status',
                data: 'isOutOfStock',
                sortable: false,
            },
            {
                header: 'Lagersaldo',
                data: 'Stock_today',
                sortable: true,
                align_right: true,
            },
            {
                header: 'På order',
                data: 'order',
                sortable: false,
                align_right: true,
                render(row) {
                    return row.Stock_today - row.Stock_future;
                },
            },
            {
                header: 'Beställt',
                data: 'ordered_total',
                sortable: true,
                align_right: true,
                render(row) {
                    return '<span class="badge ' + (row.ordered_total > 0 ? 'badge-success' : 'badge-light') + '">' + row.ordered_total + '</span>';
                },
            },
            {
                header: 'Disponibelt',
                data: 'Stock_future',
                sortable: true,
                align_right: true,
            },
            {
                header: 'Best. punkt',
                data: 'ReorderingPoint',
                sortable: true,
                align_right: true,
                class(row) {
                    let style = '';
                    if (row.ReorderingPoint >= (row.Stock_future + parseInt(row.ordered_total, 10))) {
                        style = 'bg-danger-300';
                    } else if (row.ReorderingPoint < (row.Stock_future + parseInt(row.ordered_total, 10))) {
                        style = 'bg-purple-300';
                    }
                    return style;
                },
            },
            {
                header: 'Best. datum',
                data: 'ordered_date',
                sortable: true,
                render(row) {
                    return (row.ordered_date ? row.ordered_date.substring(0, 10) : '');
                },
            },
        ],
    }),
};

</script>
